import { withSearchParams } from '@ui/util';

import { SITES, SNAP_QUOTES } from './constants';

export function param(s: string): string {
  return encodeURIComponent(s);
}

export const buildSiteUrl = (siteCode: string, path?: string) => {
  const base = `${SITES}/${siteCode}`;

  if (!path) {
    return base;
  }

  return `${base}/${path}`;
};

export const buildSnapQuoteUrl = (
  siteCode: string,
  uuid: string,
  path?: string,
  queryParams?: Record<string, string>,
) => {
  const base = buildSiteUrl(siteCode, `${SNAP_QUOTES}/${uuid}`);

  if (!path) {
    return withSearchParams(base, queryParams ?? null);
  }

  return withSearchParams(`${base}/${path}`, queryParams ?? null);
};

export const buildV2SiteUrl = (siteCode: string, path?: string) => {
  return `/v2/${buildSiteUrl(siteCode, path)}`;
};

export const buildV2Url = (path: string) => {
  return `/v2/${path}`;
};
